import React, { useEffect, useState } from 'react'
import getBackgroundImage from '../../helpers/images/getBackgroundImage'
import logo from '../../assets/images/ambunetLogo.png'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import Stack from '@mui/material/Stack'

function Copyright(props) {
  return (
    <Link
      href="https://ambunet.co.uk/"
      target="_blank"
      sx={{
        textDecoration: 'none',
        color: 'text.secondary',
        display: 'block',
      }}
    >
      <Stack direction="row" alignItems="center" gap={1}>
        <Box component="img" src={logo} alt="AmbuNet" width="4.5rem" />

        <Stack>
          <Typography fontFamily="moonlander" color="text.primary">
            AmbuNet
          </Typography>

          <Typography variant="caption" color="text.secondary" {...props}>
            Copyright © AmbuNet® {new Date().getFullYear()}.
          </Typography>
        </Stack>
      </Stack>
    </Link>
  )
}

const SplitPage = ({ children }) => {
  const [bgImage, setBgImage] = useState()

  useEffect(() => {
    setBgImage(getBackgroundImage())
  }, [])

  return (
    <Grid
      container
      component="main"
      sx={{
        minHeight: '100vh',
        background:
          'radial-gradient(circle at top right, rgba(35,154,164,0.18), transparent 32%), linear-gradient(135deg, #F8FAFC 0%, #EEF2F7 100%)',
        '@supports (height: 100dvh)': {
          minHeight: '100dvh',
        },
      }}
    >
      <Grid
        item
        md={7}
        sx={{
          position: 'relative',
          display: { xs: 'none', md: 'flex' },
          overflow: 'hidden',
          minHeight: '100vh',
          backgroundColor: '#101827',
          '@supports (height: 100dvh)': {
            minHeight: '100dvh',
          },
        }}
      >
        <Box
          component="img"
          src={bgImage}
          alt=""
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            filter: 'saturate(0.9) contrast(1.05)',
          }}
        />

        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            background:
              'linear-gradient(135deg, rgba(16,24,39,0.78) 0%, rgba(36,47,64,0.42) 45%, rgba(35,154,164,0.24) 100%)',
          }}
        />

        <Box
          sx={{
            position: 'absolute',
            left: 40,
            bottom: 40,
            right: 40,
            maxWidth: 640,
            color: 'white',

            background: 'rgba(255,255,255,0.14)',
            border: '1px solid rgba(255,255,255,0.22)',
            backdropFilter: 'blur(18px)',
            boxShadow: '0 12px 40px rgba(0,0,0,0.25)',

            borderRadius: 4,
            p: 4,
          }}
        >
          <Typography
            variant="overline"
            sx={{
              opacity: 0.85,
              letterSpacing: 1.2,
              textShadow: '0 1px 6px rgba(0,0,0,0.22)',
            }}
          >
            Welcome to AmbuNet&#174;
          </Typography>

          <Typography
            variant="h4"
            fontWeight={900}
            color="white"
            sx={{
              mt: 2,
              lineHeight: 0.95,
              maxWidth: 900,
              textWrap: 'balance',
              textShadow: '0 2px 12px rgba(0,0,0,0.28)',
            }}
          >
            Streamlining Ambulance Operations
          </Typography>

          <Typography
            variant="body1"
            sx={{
              mt: 3,
              maxWidth: 620,
              color: 'rgba(255,255,255,0.92)',
              lineHeight: 1.7,
              fontWeight: 400,
              fontSize: '1.15rem',
              textShadow: '0 1px 6px rgba(0,0,0,0.22)',
            }}
          >
            Securely manage patients, staff, vehicles, compliance and events
            from one integrated operational platform.
          </Typography>
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        md={5}
        sx={{
          height: '100vh',
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          overflow: 'hidden',
          '@supports (height: 100dvh)': {
            height: '100dvh',
          },
        }}
      >
        <Box
          sx={{
            width: '100%',
            flex: 1,
            minHeight: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'auto',
          }}
        >
          {children}
        </Box>

        <Box
          component="footer"
          sx={{
            flexShrink: 0,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            px: 2,
            py: 2,
            boxSizing: 'border-box',
          }}
        >
          <Copyright />
        </Box>
      </Grid>
    </Grid>
  )
}

export default SplitPage
